/** One-shot pop + soft ring when an attention badge first appears. */
export const ATTENTION_BADGE_POP_ANIMATION =
  "attentionBadgePop 0.55s cubic-bezier(0.34, 1.4, 0.64, 1) both, attentionBadgeRing 0.8s ease-out 0.1s both";

const reducedMotion = {
  "@media (prefers-reduced-motion: reduce)": {
    animation: "none",
  },
};

/** Inline count pills (Settings rows, hero cards, etc.). */
export const attentionBadgePopSx = {
  animation: ATTENTION_BADGE_POP_ANIMATION,
  ...reducedMotion,
};

/** MUI Badge dot/count on nav icons. */
export const attentionMuiBadgePopSx = {
  "& .MuiBadge-badge": {
    animation: ATTENTION_BADGE_POP_ANIMATION,
    ...reducedMotion,
  },
};
